module.exports = __webpack_public_path__ + "static/media/Fansbanner.99376782.jpg";